up.compiler('[vat-id-visibility]', function(fragment, options) {
  var vatRequiredCountryCodes = options.vatRequiredCountryCodes

  function update() {
    var countryCode = $('[id$=country_code]').val();
    if ( $('[id$=account_type]').val() == 'business' )  {
      if ( _(vatRequiredCountryCodes).include(countryCode) ) {
        $('.vat_id_elements').show();
      } else {
        $('.vat_id_elements').hide();
      }
      $('.company_name_elements').show();
    } else {
      $('.vat_id_elements').hide();
      $('.company_name_elements').hide();
    }

    $('.invoice_address').toggle(!$('[id$=invoice_address_same_as_above]').is(':checked'));
  }

  $(function() {
    $('[id$=account_type], [id$=country_code], [id$=invoice_address_same_as_above]').change(update);
    update();
  });
})
